import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import cx from "classnames";

// Provider
import { AppContext } from "../../../components/AppProvider";

// Utils
import { _O } from "../../../modules/utils";

// UI
import { IC, Doctor } from "../../../resources/Assets";
import { Container, DateLayer, DateTimeLayer, openLayerFn, closeLayerFn, pickerStart } from "../../Layout";
import { SUBS, SubMenu } from "./History";

export default (props) => {
    const sub = SUBS[0];
    const [type, setType] = useState("LIST");

    const handleTypeChange = (type) => {
        setType(type);
    };

    useEffect(() => {
        //혈압입력 자동입력, 수동입력 토글
        $(".toggle-inputcheck a").click(function () {
            $(this).toggleClass("off");
        });
    }, []);

    return (
        <Fragment>
            <Container Title={sub.label} bottom={getBottom({ type, onChange: handleTypeChange })}>
                <div className="contents sub">
                    <SubMenu code={sub.code} />
                    <div className="sub-contents">
                        <div className="sub-title">
                            혈당
                            <div className="toggle-inputcheck">
                                <a href={void 0}>
                                    자동입력<i></i>수동입력
                                </a>
                            </div>
                        </div>

                        {type === "LIST" && <List />}
                        {type === "CONNECT" && <Connect onChange={handleTypeChange} />}
                        {type === "CONNECTED" && <Connected />}
                        {type === "FAILURE" && <Failure />}
                    </div>
                </div>
            </Container>
        </Fragment>
    );
};

export const Settings = (props) => {
    return (
        <Container Title="기기연결" dark>
            <div className="contents">
                <div className="sub-contents">
                    <div className="device-link-contain">
                        <div>
                            <div className="round-list green">
                                <div className="title">
                                    <i className="c1"></i> 혈압계
                                </div>
                                <div>
                                    <a href={void 0} onClick={(e) => _O.Open("/sm/bp/input/device/guide")}>
                                        BP170B <span>연결됨</span>
                                    </a>
                                </div>
                                <div>
                                    <a href={void 0}>A&amp;D UA-651BLE</a>
                                </div>
                                <div>
                                    <a href={void 0}>ER3950_EAE</a>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="round-list pink">
                                <div className="title">
                                    <i className="c2"></i> 혈압계
                                </div>
                                <div>
                                    <a href={void 0}>
                                        BP170B <span>연결됨</span>
                                    </a>
                                </div>
                                <div>
                                    <a href={void 0}>A&amp;D UA-651BLE</a>
                                </div>
                                <div>
                                    <a href={void 0}>ER3950_EAE</a>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="round-list purple">
                                <div className="title">
                                    <i className="c3"></i> 혈압계
                                </div>
                                <div>
                                    <a href={void 0}>
                                        BP170B <span>연결됨</span>
                                    </a>
                                </div>
                                <div>
                                    <a href={void 0}>A&D UA-651BLE</a>
                                </div>
                                <div>
                                    <a href={void 0}>ER3950_EAE</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export const Guide = (props) => {
    const bottom = (
        <div className="under-fix-btnarea">
            <a href={void 0} className="btn-connect">
                <i></i>연결
            </a>
            {/* 연결되 있을경우 해제하기 버튼
					<a href={void 0} className="btn-unconnect"><i></i>연결 해제</a>  */}
        </div>
    );
    return (
      <Container Title="기기연결" dark bottom={bottom}>
        <div className="contents">
          <div className="sub-contents">
            <div className="linkguide-contain">
              <div className="roundbox-list">
                <div>
                  “M1” 버튼을 눌러 혈압계 전원을 켜고 연결을 준비하세요.
                </div>
                <div>앱 하단의 “연결” 버튼을 눌러 주세요.</div>
                <div>
                  연결이 완료되면 혈압계의 “시작/정지”버튼을 눌러 혈압을
                  측정하세요.
                </div>
              </div>
              <div className="guide-img">
                <img src={IC.device.guide} alt="" />
              </div>
              <div className="under-text">
                배터리가 없는 경우 배터리를 삽입하면 자동으로 전원이 켜집니다.
                <br />
                실패할 경우 다시 시도하세요.
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
};

const List = (props) => {
    return (
        <Fragment>
            <div className="device-state-info yellow">
                <i>!</i> (설정) 기기정보가 없습니다.
            </div>

            <div className="device-state-box">
                <img src={IC.device.nothing2} alt="" />
                <p>
                    기기 정보가 없습니다.
                    <br />
                    측정 가능한 기기를 연결해 주세요.
                </p>
            </div>
        </Fragment>
    );
};

const Connect = (props) => {
    useEffect(() => {
        setTimeout(() => {
            props.onChange && props.onChange("CONNECTED");
        }, 2000);
    }, []);

    return (
        <Fragment>
            <div className="device-state-info orange">
                <i>!</i> InBody_BP170B 연결중
            </div>
            <div className="device-state-box">
                <div className="connecing"></div>
                <p>기기 연결중입니다.</p>
            </div>
        </Fragment>
    );
};

const Connected = (props) => {
    return (
        <Fragment>
            <div className="device-state-info yellow">
                <i>!</i> InBody_BP170B와 연결되었습니다.
            </div>
            <div className="device-state-box">
                <img src={IC.device.success} alt="" />
                <p>기기와 연결 되었습니다.</p>
            </div>
        </Fragment>
    );
};

const Failure = (props) => {
    return (
        <Fragment>
            <div className="device-state-info red">
                <i>!</i> (설정) InBody_BP170B 연결이 실패하였습니다.
            </div>
            <div className="device-state-box">
                <img src={IC.device.failure} alt="" />
                <p>
                    자동연결이 실패 하였습니다.
                    <br />
                    측정 가능한 기기를 다시 연결해 주세요.
                </p>
            </div>
        </Fragment>
    );
};

const getBottom = ({ type, onChange }) => {
    switch (type) {
        case "LIST":
            return (
                <div className="under-fix-btnarea">
                    <a href={void 0} className="btn-connect" onClick={(e) => onChange("CONNECT")}>
                        <i></i>연결
                    </a>
                </div>
            );
        case "CONNECTED":
            return (
                <div className="under-fix-btnarea">
                    <a href={void 0} className="btn-half-box cc" onClick={(e) => onChange("FAILURE")}>
                        <i></i>취소
                    </a>
                    <a href={void 0} className="btn-half-box ok">
                        <i></i>확인
                    </a>
                </div>
            );
        case "FAILURE":
            return (
                <div className="under-fix-btnarea">
                    <a href={void 0} className="btn-half-box set">
                        <i></i>설정
                    </a>
                    <a href={void 0} className="btn-half-box relink" onClick={(e) => _O.Open("/sm/bp/input/device/settings")}>
                        <i></i>재연결
                    </a>
                </div>
            );
        default:
            return null;
    }
};
